export enum PaymentMethod {
  BANK_TRANSFER = 'BANK_TRANSFER',
  CASH = 'CASH',
  CARD = 'CARD',
  CHECK = 'CHECK',
  CRYPTOCURRENCY = 'CRYPTOCURRENCY',
  OTHER = 'OTHER'
}

export enum PaymentStatus {
  PENDING = 'PENDING',
  CONFIRMED = 'CONFIRMED',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
  REFUNDED = 'REFUNDED'
}

export interface Payment {
  id: string;
  invoiceId: string;
  invoiceNumber: string;
  currency: string;
  amount: number;
  paymentDate: string;
  method: PaymentMethod;
  status: PaymentStatus;
  transactionReference?: string;
  notes?: string;
  bankTransactionId?: string;
  processedAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreatePaymentRequest {
  amount: number;
  paymentDate: string;
  method: PaymentMethod;
  status: PaymentStatus;
  transactionReference?: string;
  notes?: string;
}

export interface OutstandingAmountResponse {
  outstandingAmount: number;
}

export interface MatchPaymentRequest {
  bankTransactionId: string;
}

export const PaymentMethodLabels: Record<PaymentMethod, string> = {
  [PaymentMethod.BANK_TRANSFER]: 'Банковский перевод',
  [PaymentMethod.CASH]: 'Наличные',
  [PaymentMethod.CARD]: 'Карта',
  [PaymentMethod.CHECK]: 'Чек',
  [PaymentMethod.CRYPTOCURRENCY]: 'Криптовалюта',
  [PaymentMethod.OTHER]: 'Другое'
};

export const PaymentStatusLabels: Record<PaymentStatus, string> = {
  [PaymentStatus.PENDING]: 'Ожидает',
  [PaymentStatus.CONFIRMED]: 'Подтвержден',
  [PaymentStatus.FAILED]: 'Неудачный',
  [PaymentStatus.CANCELLED]: 'Отменен',
  [PaymentStatus.REFUNDED]: 'Возвращен'
};

export const PaymentStatusColors: Record<PaymentStatus, string> = {
  [PaymentStatus.PENDING]: 'bg-yellow-100 text-yellow-800',
  [PaymentStatus.CONFIRMED]: 'bg-green-100 text-green-800',
  [PaymentStatus.FAILED]: 'bg-red-100 text-red-800',
  [PaymentStatus.CANCELLED]: 'bg-gray-100 text-gray-800',
  [PaymentStatus.REFUNDED]: 'bg-blue-100 text-blue-800'
};
